import constant from "../../../../../constants/constant"
import { TStoreDropDown, TSupplierDropDown } from "../interface";

export const useDropDown=()=>{
    const getStoreDropdown = (response: any[]): TStoreDropDown[] => {
        return response.map((item) => ({
            value: item.id,
            // use store_location if not null/undefined, otherwise store_name
            label: item.store_location ?? item.store_name, 
            region_code: item.region || constant.STORE_REGION.INDIA,
            store_code: item?.store_code || ''
        }));
    };

    const getSupplierDropdown = (response: any[]): TSupplierDropDown[] => {
        return response.map((item) => ({
            value: item.id,
            label: item?.supplier_name || '', 
            gst_type: item.gst_type || ''
        }));
    };


    
    return{
        getStoreDropdown,
        getSupplierDropdown
    }
}